module.exports = __webpack_public_path__ + "static/media/patter-1.c6d47623.png";